import { render } from "./SlideVisualizer.vue?vue&type=template&id=046faf07"
import script from "./SlideVisualizer.vue?vue&type=script&lang=js"
export * from "./SlideVisualizer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__